"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: theme_1.default.shadows.medium,
        '& th': {
            textAlign: 'left',
            backgroundColor: 'white',
        },
        '& th:first-child': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
        },
        '& th:last-child': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
        },
    },
    sticky: {
        '& th': {
            position: 'sticky',
            top: 0,
        },
    },
    thead: {
        display: 'table-header-group',
    },
}));
